import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { getFormFieldAppearance } from '../services/runtime-config';

/**
 * Provider globale per `MAT_FORM_FIELD_DEFAULT_OPTIONS` che imposta l'appearance
 * di default di tutti i `mat-form-field` del portale leggendo il flag
 * `ui.formFieldAppearance` dal `runtime-config.json` tramite
 * {@link getFormFieldAppearance}.
 *
 * Va spreddato nei `providers` di `bootstrapApplication` in ogni installazione,
 * cosi' l'appearance scelta in runtime-config viene applicata a TUTTI i
 * form-field del portale (filter-panel, dialog, top-bar, pagine custom,
 * CRUD, ...) senza dover replicare il provider in ogni componente.
 *
 * Eccezioni: un componente che vuole forzare una appearance specifica puo'
 * dichiarare un proprio `viewProviders` con `MAT_FORM_FIELD_DEFAULT_OPTIONS`
 * (es. `sia-mat-grid` forza `'fill'`), che vince per il suo sotto-albero.
 */
export function provideFormFieldAppearance(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useFactory: () => ({ appearance: getFormFieldAppearance() }),
    },
  ]);
}
